import { useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';

export const PromoCodePage = () => {
  const location = useLocation();

  useEffect(() => {
    const matches = location.search.match(/\?c=(promo_[\w\d]+)/);
    if (matches && matches[1]) {
      localStorage.setItem('promo', matches[1]);
    }
    window.location.replace(window.location.pathname.replace(/\/promo\/?/, '/register'));
  }, [location]);

  return (
    <Container>
      <p>
        <i className='fa-spin fa-spinner fas ms-2' />
      </p>
    </Container>
  );
};
